import { writable } from 'svelte/store';

export const store = writable(null); // start with no user